module.exports = __webpack_public_path__ + "img/ms.3c6c891a.png";